import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface RadioGroupInputOption {
  id: string | number;
  value: string;
  name?: string;
}

@Component({
  selector: 'app-radio-group-input',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './radio-group-input.component.html',
  styleUrls: ['./radio-group-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioGroupInputComponent {
  @Input() options: RadioGroupInputOption[] = [];
  @Input() selectedOption?: RadioGroupInputOption;
  @Input() hasError = false;

  @Output() selectionChange = new EventEmitter<RadioGroupInputOption>();

  onOptionSelected(option: RadioGroupInputOption): void {
    this.selectedOption = option;
    this.selectionChange.emit(option);
  }
}
